import { colors } from '../colors';

export const icon = {
  color: colors.gray[900],
};
